export default __webpack_public_path__ + "static/boook-10f3aba6627e2ff9b9d5922571b6d1c7.png";